import {
  Box,
  TextField,
} from '@mui/material';
import styled from 'styled-components';
import {
  P,
  screenMdMin,
} from '@shared/styles/index.js';
import Button from '@shared/components/Buttons/Button.js';
import { MOBILE_BREAKPOINT } from '@shared/styles/Breakpoints.js';

export const StyledSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;
  justify-content: space-between;
  margin: var(--spacing-sm) 0;
  @media ${screenMdMin} {
    flex-direction: unset;
  }
`;

export const SaveBar = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  border-top: 1px solid #e5e7eb;
  padding: var(--spacing-sm) var(--spacing-md);
  display: flex;
  justify-content: center;
  z-index: 10;
`;

export const SaveButton = styled(Button).attrs({
  'className': 'review-save-button',
  'data-testid': 'review-save-button',
})`
  && {
    border-radius: 999px;
    padding: 10px 18px;
    font-weight: 700;
    box-shadow: 0 8px 16px rgba(16, 24, 40, 0.15);    
  }
`;

export const StyledPublishButton = styled(Button)`
  text-transform: capitalize;
  border-radius: 24px;
  width: 250px;
  height: 85px;
  font-size: 18px;
  color: var(--color-black);
  background-color: #f0d5c7;
  &:hover {
    background-color: #f0d5c7;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-md);
`;

export const Container = styled.div`
  margin: var(--spacing-md);
  display: flex;
  flex-direction: column;
`;

export const StyledText = styled(P)<{ spaceleft?: boolean }>`
  margin: var(--spacing-sm) 0;
  // max-width: 60%;
  font-size: 14px;
  @media ${screenMdMin} {
    margin-left: ${({ spaceleft }) => {
      return (spaceleft ? 'var(--spacing-md)' : '0');
    }};
  }
`;

export const StyledTextField = styled(TextField)<{ wide?: string }>`
  width: 100%;
  @media ${screenMdMin} {
    margin-top: var(--spacing-xs);
  }
`;

export const QuestionCard = styled(Box)`
  background: #fff;
  border: 1px solid var(--color-grey);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.06);
  width: 100%;
  // min-height: 250px;
  margin: var(--spacing-sm) 0;
  padding: var(--spacing-md);

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-bottom: 0;
  }
`;
